export default angular
  .module('doxy.common.services.externalDataFactory', [])
  .factory('externalDataFactory', function ($http, $q, apiUrl) {
    const fallback = 'en';

    function _getUrl(name, language) {
      return (
        apiUrl + '/data/' + name + (language ? '.' + language : '') + '.json'
      );
    }

    function get(name, language) {
      language = language || fallback;
      const deferred = $q.defer();

      function resolve(res) {
        deferred.resolve(res.data);
      }

      $http.get(_getUrl(name, language))
        .then(resolve)
        .catch(() => {
          $http.get(_getUrl(name, fallback))
            .then(resolve)
            .catch(deferred.reject);
        });

      return deferred.promise;
    }

    return {
      get,
    };
  }).name;
